import {createActions} from 'redux-arc';
import {GET} from './types';

const medicineApiBase = 'medicine/';

export const {types, creators: medicineCreators} = createActions('medicine', {
  read: {url: `${medicineApiBase}:id/`, method: GET},
  list: {url: medicineApiBase, method: GET}
});
